import styled from 'styled-components';

// Shown while the socket is down: tiles keep their last known state until it
// reconnects, and then every device is refreshed from the server.
const LiveUpdatesPaused = () => (
  <Banner role='status'>live updates paused, reconnecting…</Banner>
);

export default LiveUpdatesPaused;

const Banner = styled.div`
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  padding: 6px 16px;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fcff01;
  font-size: 12px;
  letter-spacing: 1.2px;
  white-space: nowrap;
  pointer-events: none;
`;
